var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjDivider", { attrs: { "right-fixed": "" } }, [
        _vm._v(_vm._s(_vm.$t("billingPage.BillingInvoiceReport"))),
      ]),
      _c(
        "el-form",
        {
          ref: "reportRef",
          staticClass: "bj-query-form bj-query-form-for-cal-height relative",
          attrs: { size: "mini", model: _vm.queryParams },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("form.startDateText") } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          id: "getWeekDate1",
                          "picker-options": _vm.pickerOptions1,
                          type: "week",
                          format: "yyyy-WW",
                          clearable: false,
                          placeholder: _vm.$t("billingPage.yearAndWeeks"),
                        },
                        on: { change: _vm.changeWeek1 },
                        model: {
                          value: _vm.weekDataNow1,
                          callback: function ($$v) {
                            _vm.weekDataNow1 = $$v
                          },
                          expression: "weekDataNow1",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("form.endDateText") } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          id: "getWeekDate2",
                          "picker-options": _vm.pickerOptions2,
                          type: "week",
                          format: "yyyy-WW",
                          clearable: false,
                          placeholder: _vm.$t("billingPage.yearAndWeeks"),
                        },
                        on: { change: _vm.changeWeek2 },
                        model: {
                          value: _vm.weekDataNow2,
                          callback: function ($$v) {
                            _vm.weekDataNow2 = $$v
                          },
                          expression: "weekDataNow2",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.activeName != "BillingPageInvoiceReportClientQty"
                ? _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("billingPage.companySeller"),
                            prop: "clientCode",
                          },
                        },
                        [
                          _c("BjSelectLov", {
                            attrs: {
                              placeholder: _vm.$t("billingPage.companySeller"),
                              multiple: true,
                              "option-list": _vm.clientCodeList,
                            },
                            on: { change: _vm.changeClientCode },
                            model: {
                              value: _vm.queryParams.clientCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParams, "clientCode", $$v)
                              },
                              expression: "queryParams.clientCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.activeName == "BillingPageInvoiceReportClient" ||
              _vm.activeName == "BillingPageInvoiceReportPostage"
                ? _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("billingPage.IRclientType"),
                            prop: "clientType",
                          },
                        },
                        [
                          _c("BjSelectLov", {
                            attrs: {
                              placeholder: _vm.$t("billingPage.IRclientType"),
                              "option-list": _vm.clientTypeList,
                            },
                            on: { change: _vm.changeClientType },
                            model: {
                              value: _vm.queryParams.clientType,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParams, "clientType", $$v)
                              },
                              expression: "queryParams.clientType",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.activeName == "BillingPageInvoiceReportSales"
                ? _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("billingPage.Sales"),
                            prop: "sales",
                          },
                        },
                        [
                          _c("BjSelectLov", {
                            attrs: {
                              placeholder: _vm.$t("billingPage.Sales"),
                              multiple: "true",
                              "option-list": _vm.salesList,
                            },
                            on: { change: _vm.changeSales },
                            model: {
                              value: _vm.queryParams.sales,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParams, "sales", $$v)
                              },
                              expression: "queryParams.sales",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-col",
            {
              staticStyle: {
                position: "absolute",
                bottom: "0",
                right: "0",
                "margin-bottom": "18px",
                display: "flex",
                "justify-content": "flex-end",
              },
              attrs: { span: _vm.colSpan },
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", plain: "" },
                  on: { click: _vm.search },
                },
                [_vm._v(_vm._s(_vm.$t("searchText")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "default", plain: "" },
                  on: {
                    click: function ($event) {
                      _vm.reset()
                      _vm.search()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("resetText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          on: { "tab-click": _vm.tabClick },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        _vm._l(_vm.BILLING_PAGE_INVOICE_REPORT_LIST, function (item) {
          return _c("el-tab-pane", {
            key: item.value,
            attrs: { label: _vm.$t("route." + item.value), name: item.value },
          })
        }),
        1
      ),
      _vm.isShow
        ? _c(
            "div",
            [
              _vm.activeName == "BillingPageInvoiceReportTotal"
                ? _c("total", {
                    ref: "totalRef",
                    attrs: { "chart-data": _vm.chartData },
                  })
                : _vm._e(),
              _vm.activeName == "BillingPageInvoiceReportPallet"
                ? _c("pallet", {
                    ref: "palletRef",
                    attrs: { "chart-data": _vm.chartData },
                  })
                : _vm._e(),
              _vm.activeName == "BillingPageInvoiceReportCBM"
                ? _c("CBM", {
                    ref: "CBMRef",
                    attrs: { "chart-data": _vm.chartData },
                  })
                : _vm._e(),
              _vm.activeName == "BillingPageInvoiceReportClientQty"
                ? _c("clientqty", {
                    ref: "clientqtyRef",
                    attrs: { "chart-data": _vm.chartData },
                    on: { sortChange: _vm.sortChange },
                  })
                : _vm._e(),
              _vm.activeName == "BillingPageInvoiceReportClient"
                ? _c("client", {
                    ref: "clientRef",
                    on: { sortChange: _vm.sortChange },
                    model: {
                      value: _vm.queryParams,
                      callback: function ($$v) {
                        _vm.queryParams = $$v
                      },
                      expression: "queryParams",
                    },
                  })
                : _vm._e(),
              _vm.activeName == "BillingPageInvoiceReportPostage"
                ? _c("postage", {
                    ref: "postageRef",
                    on: { sortChange: _vm.sortChange },
                    model: {
                      value: _vm.queryParams,
                      callback: function ($$v) {
                        _vm.queryParams = $$v
                      },
                      expression: "queryParams",
                    },
                  })
                : _vm._e(),
              _vm.activeName == "BillingPageInvoiceReportSales"
                ? _c("sales", {
                    ref: "salesRef",
                    on: { sortChange: _vm.sortChange },
                    model: {
                      value: _vm.queryParams,
                      callback: function ($$v) {
                        _vm.queryParams = $$v
                      },
                      expression: "queryParams",
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }